import { findCompanyId } from "../../../infrastructure/repository/company-repository";
import renderRentingRequestsTable from "../../../infrastructure/renders/RentingRequestsTable/render-renting-requests-table";
import { listCompanyRequests } from "../../../infrastructure/repository/request-repository";

export default async function reviewRentingRequests() {
  renderRentingRequestsTable({ isLoading: true });
  const companyId = await findCompanyId();
  const { data } = await listCompanyRequests({
    companyId,
    category: "renting-benefit",
  });
  renderRentingRequestsTable({ requests: data });
}
